import { env } from '../../../config/env';

export const getYoutubeEmbedUrls = (urlOrUrls?: string | string[]): string[] => {
  if (!urlOrUrls) {
    return [];
  }
  const rawItems: string[] = Array.isArray(urlOrUrls)
    ? urlOrUrls
    : String(urlOrUrls)
        .split(/[\r\n,]+/)
        .map((item) => item.trim())
        .filter(Boolean);

  const regExp = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})/;
  const embedUrls: string[] = [];

  for (const item of rawItems) {
    const match = item.match(regExp);
    if (match && match[1]) {
      const embed = `https://www.youtube.com/embed/${match[1]}`;
      if (!embedUrls.includes(embed)) {
        embedUrls.push(embed);
      }
    } else if (/^[\w-]{11}$/.test(item)) {
      const embed = `https://www.youtube.com/embed/${item}`;
      if (!embedUrls.includes(embed)) {
        embedUrls.push(embed);
      }
    }
  }

  return embedUrls;
};

export const getYoutubeEmbedUrl = (urlOrUrls?: string | string[]): string | null => {
  const urls = getYoutubeEmbedUrls(urlOrUrls);
  return urls.length > 0 ? urls[0] : null;
};

export const getYoutubeThumbnailUrl = (embedUrl: string): string | null => {
  if (!embedUrl) return null;
  const match = embedUrl.match(/embed\/([\w-]{11})/);
  if (match && match[1]) {
    return `https://img.youtube.com/vi/${match[1]}/mqdefault.jpg`;
  }
  return null;
};

export const getThumbnailSrc = (url?: string): string => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  const publicUrl = env().PUBLIC_URL;
  return url.startsWith('/') ? `${publicUrl}${url}` : `${publicUrl}/${url}`;
};
